<div class="guidePage">
  
   
    <kendo-grid #orderguideGrid 
                [kendoGridBinding]="gridData" 
                [filterable]="true" 
                [loading]="loading"
                [pageSize]="state.take" 
                [skip]="state.skip" 
                [reorderable]="true" 
                [resizable]="true"
                [sortable]="true" 
                [filter]="state.filter"
                [rowHeight]="48"
                (excelExport)="excelExported($event)" 
                id="grid-Ordering" 
                scrollable="virtual" 
                style="height: 80vh"
                (dataStateChange)="onChange($event)">

            <ng-template kendoGridToolbarTemplate>
                <kendo-grid-spacer></kendo-grid-spacer>
                <app-mcl-button id="but-export" (buttonPressed)="exportToPDF(orderguideGrid)" text="Export to PDF" [svgIcon]='filePdfIcon'
                    primary="true"></app-mcl-button>
                <app-mcl-button id="but-export-excel" (buttonPressed)="exportToExcel(orderguideGrid)" [svgIcon]="fileExcelIcon"
                    primary="true" text="Export to Excel"></app-mcl-button>
            </ng-template>

            <kendo-grid-column [title]="Nomenclatures.ITEM_NUMBER" field="itemNo" filterable="true" sortable="true" width="150">
                <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    <p *ngIf="gridData">
                        {{gridData.length}} Item(s) </p>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [title]="Nomenclatures.DESCRIPTION" field="description" filterable="true" width="250">

            </kendo-grid-column>
            <kendo-grid-column [title]="Nomenclatures.BUILD_TO_QTY" field="buildToQty" filterable="true"  width="140">

            </kendo-grid-column>
            <kendo-grid-column-group title="Order Quantity" width="350">
                <kendo-grid-column [title]="1" width="50">
                </kendo-grid-column>
                <kendo-grid-column [title]="2" width="50">
                </kendo-grid-column>
                <kendo-grid-column [title]="3" width="50">
                </kendo-grid-column>
                <kendo-grid-column [title]="4" width="50">
                </kendo-grid-column>
                <kendo-grid-column [title]="5" width="50">
                </kendo-grid-column>
            </kendo-grid-column-group>
            <kendo-grid-column [title]="Nomenclatures.UNIT_OF_MEASURE" field="unitOfMeasure" width="150">
            </kendo-grid-column>
            <kendo-grid-column [title]="Nomenclatures.CASE_PRICE" field="perCost" width="100">
            </kendo-grid-column>
            <!-- Export PDF -->
            <kendo-grid-pdf fileName="OrderGuideWorksheet.pdf" [author]="'McLane'" [producer]="'McLane'"
                [allPages]="true" paperSize="A4" [repeatHeaders]="false" [scale]="0.8">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="1cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">

                    <div class="page-template">
                        <div class="header" *ngIf="pageNum == 1">
                            <p>SourceLink - Orderguide Work Sheet</p>
                            <p>Store: {{_storeListService.pickedIdentity}}</p>
                            <p>{{ today | date}}</p>
                        </div>
                        <div class="header" *ngIf="pageNum != 1">
                            <p>SourceLink - Orderguide Work Sheet : {{ today | date}}</p>
                        </div>
                    </div>
                </ng-template>

                <kendo-grid-column [title]="'Item #'" field="itemNo" 
                    [headerStyle]="{'font-size': '10px'}" [style]="{'font-size': '10px'}"  width="70">
                </kendo-grid-column>
                <kendo-grid-column [title]="Nomenclatures.DESCRIPTION" field="description"
                    [headerStyle]="{'font-size': '10px'}" [style]="{'font-size': '10px'}" width="200">
                </kendo-grid-column>
                <kendo-grid-column [title]="'Build To Quantity'" field="buildToQty" 

                    [style]="{'font-size': '10px'}" [headerStyle]="{'white-space': 'normal','line-height': '1.2', 'text-align': 'center','font-size': '10px'}"  width="60">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                            Build<br>To <br> Quanity
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column-group title="Order Quantity" [style]="{'font-size': '10px'}"
                    [headerStyle]="{'font-size': '10px'}">
                    <kendo-grid-column [title]="1" width="40" [headerStyle]="{'font-size': '10px'}" >
                    </kendo-grid-column>
                    <kendo-grid-column [title]="2" width="40" [headerStyle]="{'font-size': '10px'}" >
                    </kendo-grid-column>
                    <kendo-grid-column [title]="3" width="40" [headerStyle]="{'font-size': '10px'}" >
                    </kendo-grid-column>
                    <kendo-grid-column [title]="4" width="40" [headerStyle]="{'font-size': '10px'}" >
                    </kendo-grid-column>
                    <kendo-grid-column [title]="5" width="40" [headerStyle]="{'font-size': '10px'}" >
                    </kendo-grid-column>
                </kendo-grid-column-group>
                <kendo-grid-column [title]="'Unit of Measure'" field="unitOfMeasure"
                    [style]="{'font-size': '10px'}" [headerStyle]="{'font-size': '10px','white-space': 'normal','line-height': '1.2', 'text-align': 'center'}" [format]="0" width="90">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                            Unit<br>of <br> Measure
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [title]="'case price'" field="perCost"
                    [style]="{'font-size': '9px'}" 
                    [headerStyle]="{'font-size': '10px','line-height': '1.2','white-space': 'normal', 'text-align': 'center'}" width="90">
                    <ng-template kendoGridHeaderTemplate>
                        <div class="pdf-header-style">
                            Case<br>Price
                        </div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid-pdf>
            <!--Export Excel -->
            <kendo-grid-excel fileName="OrderGuideWorksheet.xlsx" [fetchData]="exportAllData">
                <kendo-excelexport-column [title]="'Item #'" field="itemNo" width="170" [cellOptions]="">
                </kendo-excelexport-column>
                <kendo-excelexport-column [title]="Nomenclatures.DESCRIPTION" field="description" width="250">
                </kendo-excelexport-column>
                <kendo-excelexport-column [title]="Nomenclatures.BUILD_TO_QTY" field="buildToQty" width="170">
                </kendo-excelexport-column>
                <kendo-excelexport-column-group title="Order Quantity" [style]="{'font-size': '10px'}"
                    [headerCellOptions]="{}">
                    <kendo-excelexport-column [title]="1" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="2" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="3" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="4" field="0" width="80">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column [title]="5" field="0" width="80">
                    </kendo-excelexport-column>
                </kendo-excelexport-column-group>
                <kendo-excelexport-column [title]="Nomenclatures.UNIT_OF_MEASURE" field="unitOfMeasure" width="170">
                </kendo-excelexport-column>
                <kendo-excelexport-column [title]="'Case Price'" field="perCost" width="170">
                </kendo-excelexport-column>
            </kendo-grid-excel>
        </kendo-grid>
    </div>